/** Card kind */
export enum CardKind {
  REAL_CARD = 0,
  PHONE_NUMBER = 1,
  PLATE = 2,
  GROUP_CARD = 3,
  //ATTENTION: even if the item "QRCODE" is NOT defined inside the server-side "enum" that defines the "CardKind" values of a Card,
  //we keep it here, because it is used for the specifc purpose of classify the type of "virtual access component" to be used in graphic supervsion.
  QRCODE = 4,
  FACE = 5,
  VIRTUAL_KEYPAD_CODE = 6,
  MAIL = 7,
  USER_ACCESS = 8,
  //ATTENTION: like "QRCODE", this value is NOT (yet) part of the server-side "CardKind" enum: it is a front-end
  //classifier used to pick the CIE reader as the "virtual access component" rendered in a graphic supervision.
  //The credential is the electronic identity card (CIE), independent from the read channel (today the uFR WiFi
  //reader, in the future also the device NFC). Align this numeric value with the server-side enum once defined.
  CIE = 9,
  UNKNOWN = 99,
}

/** Card state */
export enum CardState {
  NOT_REGISTERED = 0,
  REGISTERED = 1,
  BLOCKED_NOT_REGISTERED = 2,
  BLOCKED_REGISTERED = 3,
  UNKNOWN = 99,
}

/**
 * Card effective state.
 * ATTENTION: These values does NOT correpsond to the similar-named property of the "cards" entities as represented on server-side
 * (and registered in the DB, inside the "CARDS" table).
 * THe corrispondence between this-Enum-value | Card-state-on-server are the following:
 *  * CardEffectiveState.VERGIN == Card created, but NOT phisically written (appliable ONLY to physical cards ); VALID=1, STATE=?, BUS_WRITTEN= 0
 *  * CardEffectiveState.BUS_WRITTEN == Card created, POSSIBLY Phisycally written (if physiscal), but NOT ACTIVE; VALID=1, STATE=1, BUS_WRITTEN= 0
 * * CardEffectiveState.ACTIVE == Card created, POSSIBLY Phisycally written (if physiscal), ACTIVE AND PROPAGATED; VALID=1, STATE=1, BUS_WRITTEN= 1
 * * CardEffectiveState.BLOCKED == Card created, POSSIBLY Phisycally written (if physiscal), PROPAGATED AND BLOCKED; VALID=1, STATE=2 (BLOCKED_NOT_REGISTERED) / 3 (BLOCKED_REGISTERED), BUS_WRITTEN= 1
 * * CardEffectiveState.EXPIRED == Card created, POSSIBLY Phisycally written (if physiscal), POSSIBLY PREVIOUSLY PROPAGATED, NOW EXPIRED; VALID=1, STATE=1, BUS_WRITTEN= 0/1, card's "expirationDate + expirationTime " LESS THAN NOW.
 * * CardEffectiveState.NEED_TO_REWRITE == Card created, VALID=1, STATE=1, NOT EXPIRED, NEEDTOREWRITE=1, BUS_WRITTEN=0/1
 * * [NOT_PRESENT] == Card ELIMINATED; VALID=0, STATE=1/3, BUS_WRITTEN= 1
 */
export enum CardEffectiveState {
  VERGIN = 0,
  BUS_WRITTEN = 1,
  ACTIVE = 2,
  BLOCKED = 3,
  EXPIRED = 4,
  NEED_TO_REWRITE = 5
}

/**
 * Handle Card expiration state
 */
export enum CardExpirationState {
  NOT_YET_ALLOWED = 0,
  ALLOWED = 1,
  EXPIRED = 2,
}

/**
 * Handle card type
 */
export enum CardType {
  GUEST = 0,
  SERVICE = 1,
  SAFLOCK_SYSTEM6000_GUEST = 1,
  SALTO_IS_GUEST = 1,
  MAINTANANCE = 2,
  SAFLOCK_SYSTEM6000_CONNECTOR = 2,
  SALTO_IS_STAFF = 2,
  INSTALLER = 3,
  SAFLOCK_SYSTEM6000_MULTICONNECTOR = 3,
  SALTO_IS_SPECIAL = 3,
  SECURITY = 4,
  SAFLOCK_SYSTEM6000_LIMITEDUSE = 4,
  ASSISTENCE = 5,
  ADMINISTRATOR = 6,
  PHONE = 7,
  MASTER_UNCONDITIONAL_OPEN = 20,
  MASTER_WHITE_LIST_ADD = 21,
  MASTER_WHITE_LIST_DELETE = 22,
  MASTER_WHITE_LIST_RESET = 23,
  MASTER_BLACK_LIST_ADD = 24,
  MASTER_BLACK_LIST_DELETE = 25,
  MASTER_BLACK_LIST_RESET = 26,
  MASTER_ACCESS_STRATEGY_WHITE_LIST = 27,
  MASTER_ACCESS_STRATEGY_BLACK_LIST = 28,
  MASTER_ACCESS_STRATEGY_CENTRALIZED = 29,
  MASTER_NOTIFICATION_METHOD_SPONTANEOUS_EMISSION = 30,
  MASTER_NOTIFICATION_METHOD_POLLING = 31,
  MASTER_PLANT_CODE_ADD = 32,
  MASTER_PLANT_CODE_DELETE = 33,
  MASTER_PLANT_CODE_RESET = 34,
  MASTER_ENABLE_TIME_SLOTS = 35,
  MASTER_DISABLE_TIME_SLOTS = 36,
  MASTER_PRICE_PROFILE_ADD = 37,
  MASTER_PRICE_PROFILE_DELETE = 38,
  MASTER_PRICE_PROFILE_RESET = 39,
  MASTER_ENABLE_POS = 40,
  MASTER_DISABLE_POS = 41,
  MASTER_ENABLE_PBI = 42,
  MASTER_DISABLE_PBI = 43,
  MASTER_ACCESS_STRATEGY_NO_TAG = 44,
  MASTER_DEVICE_RESET = 45,
  MASTER_REPORT_ROOM_CLEANING = 46,
  MASTER_REPORT_RECEPTION_MESSAGE = 47,
  MASTER_REPORT_MINIBAR_LED = 48,
  MASTER_TIME_SLOTS_RESET = 49,
  MASTER_ENABLE_MAC = 50,
  MASTER_DISABLE_MAC = 51,
  MASTER_TURN_OFF_LED = 52,
  MASTER_ASSOCIATED_RELAY_A_TO_CUSTOMER_GROUP = 53,
  MASTER_ASSOCIATED_RELAY_A_TO_SERVICE_GROUP = 54,
  MASTER_ASSOCIATED_RELAY_B_TO_CUSTOMER_GROUP = 55,
  MASTER_ASSOCIATED_RELAY_B_TO_SERVICE_GROUP = 56,
  MASTER_DELETE_RELAY_A_ASSOCIATION = 57,
  MASTER_DELETE_RELAY_B_ASSOCIATION = 58,
  MASTER_ROOM_CLEAN = 59,
  MASTER_MINI_BAR_EMPTY = 60,
  MASTER_MINI_BAR_FULL = 61,
  MASTER_MAINTANANCE_REQUEST = 62,
  MASTER_MAINTANANCE_REQUEST_UNO = 63,
  MASTER_ROOM_NOT_USABLE = 64,
  MASTER_ROOM_USABLE = 65,
  CIE = 66,
  NO_TYPE = 99,
}

/**
 * Handle generic MAC card type
 */
export enum MAC_CardType {
  UNKNOWN = 0x00,
  CUSTOMER = 0xce,
  SERVICE = 0xf0,
}
